import getMobileOS from '~utils/get-mobile-os'

const mobileOS = getMobileOS()

const HeaderBlock = () => {
  return mobileOS !== 'Android' ? (
    <div className="w-full h-5 flex items-center px-1 pt-2 shrink-0"></div>
  ) : null
}

export default HeaderBlock
